import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { DumbMemberDiscount } from '../DTOs/dumb-member-discount';
import { GetMemberDiscountsRequest } from '../DTOs/get-company-discounts-search-request';
import { GetPublicMembersRequest } from '../DTOs/get-public-members-request';
import { PublicMemberSearchResults } from '../DTOs/public-member-search-results';
import { MemberInformationService } from '../member-information.service';
import { DumbMemberDiscountDtInfo } from '../DTOs/dumb-member-discount-dt-info';

@Component({
  selector: 'app-member-discounts',
  templateUrl: './member-discounts.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class MemberDiscountsComponent {
  constructor(private memberInformationService: MemberInformationService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {
  }

  fromSearch = 0;
  statusSearch = 0;
  searchText = "";

  page: number = 1;
  totalResults: number = 0;
  itemsPerPage: number = 8;
  recordsFiltered: number = 0;
  initialLoad = true;

  get currentPageNum() { return this.page };
  set currentPageNum(page: number) {
    this.page = page;
    if (!this.initialLoad)
      this.searchDiscounts();
  }

  discounts: DumbMemberDiscount[] = [];


  ngOnInit() {
    this.searchDiscounts();
  }

  searchDiscountsObservable(): Observable<DumbMemberDiscountDtInfo> {
    var req = new GetMemberDiscountsRequest(this.fromSearch, this.statusSearch, this.searchText, this.currentPageNum-1);
    return this.memberInformationService
      .searchMemberDiscounts(req);
  }

  searchDiscounts(clearResults = false) {
    this.blockUI.start();

    this.searchDiscountsObservable()
      .subscribe(
        {
          next: (data) => {
            this.initialLoad = false;
            this.totalResults = data.recordsTotal;
            this.recordsFiltered = data.recordsFiltered;
            this.discounts = data.data;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }
}
